import React from 'react';
import Button from '@amzn/meridian/button';
import Row from '@amzn/meridian/row';
import Icon from '@amzn/meridian/icon';
import plusCircleTokens from '@amzn/meridian-tokens/base/icon/plus-circle';

export const ManageWorkflowButtons = ({
  editable,
  onRevert,
  onDelete,
  onSave,
  onEnableEditing,
  onAddSubworkflow,
  hasSubworkflows,
}) => {
  return (
    <Row width="100%" widths={['fill', 'fit']}>
      <div>
        {editable ? (
          <Button variant="info" onClick={onAddSubworkflow}>
            <Icon tokens={plusCircleTokens} /> Add New Subworkflow
          </Button>
        ) : null}
      </div>
      <div className="pr-4">
        {editable ? (
          <Button type="secondary" disabled={false} className="m-1" onClick={onRevert}>
            Revert Changes
          </Button>
        ) : null}
        {hasSubworkflows ? null : (
          <Button type="secondary" disabled={false} className="m-1" onClick={onDelete}>
            Delete Workflow
          </Button>
        )}
        {!editable ? (
          <Button className="m-1" onClick={onEnableEditing}>
            Edit from this Revision
          </Button>
        ) : null}
        {editable ? (
          <Button disabled={false} className="m-1" onClick={onSave}>
            Save
          </Button>
        ) : null}
      </div>
    </Row>
  );
};
